import React from 'react';
import { useTheme } from '@mui/material';
import { Typography, TypographyProps } from '@talentmesh/core';

const Body1Typography: React.FC<TypographyProps> = (props) => {
    const theme = useTheme();
    return <Typography {...props} variant="body1" color={theme.palette.secondary.light} />;
};
export default Body1Typography;
